type SpinnerProps = {
  message?: string
}

const Spinner = ({ message }: SpinnerProps) => {
  const indicator = (
    <span
      className='spinner-border spinner-border-sm'
      role={message ? undefined : 'status'}
      aria-hidden='true'
    />
  )

  if (!message) {
    return indicator
  }

  return (
    <div className='d-flex flex-column align-items-center justify-content-center text-center' role='status' aria-live='polite'>
      {indicator}
      <p className='text-muted mt-3 mb-0'>{message}</p>
    </div>
  )
}

export default Spinner
